const $ = window.jQuery;
window.app.factory("addressComplete", [
  "$http",
  function($http) {
    return function addressComplete(cfg) {
      const {
        key,
        mainInput,
        countryInput,
        mappings,
        addressObj,
        customOptions
      } = cfg;

      const baseURL =
        "http://ws1.postescanada-canadapost.ca/addresscomplete/interactive";

      function find(q, cb) {
        const country = $(countryInput).val();
        $http({
          url:
            `${baseURL}/find/v2.10/json3ex.ws?key=${key}` +
            `&country=${country}&searchTerm=${encodeURIComponent(q)}`
        }).then(res => {
          const items = res.data.Items.filter(i => i.Next === "Retrieve");
          if (items.length) {
            cb(items);
          }
        });
      }

      function retrieve(id) {
        $http({
          url: `${baseURL}/retrieve/v2.10/json3ex.ws?key=${key}&id=${id}`
        }).then(res => {
          if (res.data.Items && res.data.Items[0]) {
            console.warn("Picked", res.data.Items[0]);
            const data = res.data.Items[0];
            Object.keys(mappings).forEach(k => {
              addressObj[k] = data[mappings[k]];
            });
          }
        });
      }

      $(mainInput).typeahead("destroy");
      $(mainInput).typeahead({
        fitToElement: true,
        source: find,
        minLength: 6,
        delay: 300,
        items: "all",
        afterSelect: x => {
          console.warn("After select:", x);
          $(mainInput).val("");
          retrieve(x.Id);
        },
        displayText: o => {
          console.warn("Display option", o);
          return o.Text ? o.Text + " - " + o.Description : "";
        },
        matcher: x => true,
        updater: x => ({ Id: x.Id }),
        ...customOptions
      });
    };
  }
]);



// WEBPACK FOOTER //
// ./src/services/addressComplete.js